module.exports = __webpack_public_path__ + "img/logo.8d623681.png";